import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';

import { actions } from '../../utils/constants';
import {
    requestFileUpload,
    updateClass,
    requestUrlToUploadAttachment,
    requestUploadAttachment,
    requestAttachmentsList,
    downloadingAttachment,
    deleteAttachment,
    updateClassesTemplateTests,
} from '../../utils/common-functions';
import { userInformation } from '../login/login.saga';
import { mode } from '../../settings';
import { updateCourses } from '../courses/courses.saga';

function* fetchAppData() {
    yield call(userInformation);
}

function* updateClasses() {
    const changedClasses = yield select(({ App }) => App.changedClasses);
    let classes = yield select(({ classes }) => classes.data);
    if (!classes || !classes.length) {
        classes = yield select(({ App }) => App.classes.data);
    }
    try {
        for (const changedClassId of changedClasses) {
            const changedClass = classes.find(
                c => c.classId === changedClassId,
            );
            if (changedClass) {
                const {
                    typeTestsValues,
                    ...valuesToUpdateClass
                } = changedClass;

                const update = { ...valuesToUpdateClass, courseId: undefined };
                yield call(updateClass, update.classId, update);
                if (typeTestsValues) {
                    yield call(updateClassesTemplateTests, {
                        classId: valuesToUpdateClass.classId,
                        data: typeTestsValues,
                    });
                }
            }
        }
    } catch (err) {
        if (
            err.response &&
            err.response.data.error_description ===
                'Teste deve ter status diferente de Incompleto'
        ) {
            yield put({
                type: actions.REQUEST_ERROR,
                payload: {
                    message:
                        'O teste está incompleto e não pode ser selecionado para a turma',
                },
            });
        } else {
            yield put({
                type: actions.REQUEST_ERROR,
                payload: {
                    message:
                        'As alterações não puderam ser salvas. Tente novamente',
                },
            });
        }

        throw err;
    }
}

function* saveChanges() {
    try {
        // yield all([call(updateClasses), call(updateCourses)]);
        yield call(updateClasses);
        yield call(updateCourses);
        yield put({ type: actions.CHANGES_SAVED });
    } catch (error) {
        yield put({
            type: actions.REQUEST_ERROR,
            payload: { error, message: error.message, hidden: mode.isRelease },
        });
    }
}

function* uploadFile({ payload }) {
    const { dataUri, cb, mime } = payload;
    try {
        const response = yield requestFileUpload(dataUri, { mime });
        yield call(cb, response.data.uri);
    } catch (e) {
        yield put({
            type: actions.REQUEST_ERROR,
            payload: { message: 'O upload falhou. Tente novamente' },
        });
    }
}

function* uploadAttachment({ payload }) {
    const { dataUri, mime, filename, classId, userId, callback } = payload;
    let alerts = yield select(({ App }) => App.alerts);
    try {
        const response = yield requestUrlToUploadAttachment(
            userId,
            classId,
            mime,
            filename,
        );
        yield call(requestUploadAttachment, response.data.url, dataUri, {
            fileName: filename,
            mime,
        });
        yield call(callback, true);
        alerts.push({
            type: 'success',
            title: 'Sucesso',
            message: 'Upload concluido com sucesso',
        });
        yield put({ type: actions.UPDATE_ALERTS, payload: alerts });
    } catch (error) {
        yield call(callback, false);
        alerts.push({
            type: 'danger',
            title: 'Erro',
            message: 'O upload falhou. Tente novamente',
        });
        yield put({ type: actions.UPDATE_ALERTS, payload: alerts });
    }
}

function* gettingAttachsList({ payload }) {
    const { userId, classId, callback } = payload;
    let alerts = yield select(({ App }) => App.alerts);
    try {
        const response = yield requestAttachmentsList(userId, classId);
        yield call(callback, response.data);
    } catch (error) {
        yield call(callback, []);
        alerts.push({
            type: 'danger',
            title: 'Erro',
            message: 'Não foi possivel localizar anexos. Tente novamente',
        });
        yield put({ type: actions.UPDATE_ALERTS, payload: alerts });
    }
}

function* downloadingAttach({ payload }) {
    const { userId, classId, attachId, callback } = payload;
    let alerts = yield select(({ App }) => App.alerts);

    try {
        const { data } = yield downloadingAttachment(userId, classId, attachId);

        let downloadLink = document.createElement('a');
        downloadLink.download = 'download';
        downloadLink.innerHTML = 'Download File';
        downloadLink.href = data.url;
        downloadLink.target = '_blank';
        downloadLink.style.display = 'none';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        yield call(callback);
    } catch (error) {
        yield call(callback);
        alerts.push({
            type: 'danger',
            title: 'Erro',
            message: 'Download não conclúido. Tente novamente',
        });
        yield put({ type: actions.UPDATE_ALERTS, payload: alerts });
    }
}

function* deleteAttach({ payload }) {
    const { userId, classId, attachId, callback } = payload;
    let alerts = yield select(({ App }) => App.alerts);

    try {
        yield deleteAttachment(userId, classId, attachId);
        alerts.push({
            type: 'success',
            title: 'Sucesso',
            message: 'Anexo removido com sucesso',
        });
        yield put({ type: actions.UPDATE_ALERTS, payload: alerts });
        yield call(callback, true);
    } catch (error) {
        yield call(callback, false);
        alerts.push({
            type: 'danger',
            title: 'Erro',
            message: 'Download não conclúido. Tente novamente',
        });
        yield put({ type: actions.UPDATE_ALERTS, payload: alerts });
    }
}

export default function* app() {
    yield takeLatest(actions.ASYNC_FETCH_APP_DATA, fetchAppData);
    yield takeEvery(actions.ASYNC_SAVE_CHANGES, saveChanges);
    yield takeEvery(actions.UPLOAD_FILE, uploadFile);
    yield takeEvery(actions.UPLOAD_ATTACHMENT, uploadAttachment);
    yield takeEvery(actions.GETTING_ATTACHMENTS, gettingAttachsList);
    yield takeEvery(actions.DOWNLOADING_ATTACH, downloadingAttach);
    yield takeEvery(actions.DELETING_ATTACH, deleteAttach);
}



// WEBPACK FOOTER //
// ./src/components/app/app.saga.js